import videojs from 'video.js';
import ChatApi from './chat-api.js';
import AuthService from './auth-service/auth-service.js';
import './chat-button-toggle-messanger';
import './chat-messanger';
import './chat-popup';
import utils from './utils';
import './videojs-chat.css';
import { composeUI } from '../../js/compose-ui/index.js';
import './likes.js';
import './likes.scss';
import { ButtonAttach } from './button-attach';
import { ErrorAttachFile } from './error-attach-file';
import { AttachedFiles } from './attached-files';
import { ModalDialogWithImage } from './modal-dialog-with-image';

const Component = videojs.getComponent('Component');
const browser = videojs.browser;

// Данная проверка актуальна только для старой версии VideoJS (до версии 8.19.1)
// После перехода на новую версию VideoJS (версия 8.19.1) данную проверку нужно удалить и оставить (browser.IS_CHROMIUM && !browser.IS_EDGE)
const IS_CHROME = browser.IS_CHROMIUM === undefined ? browser.IS_CHROME : browser.IS_CHROMIUM && !browser.IS_EDGE;

// Проверка на iPad и браузеры Chrome или Safari
const isIpadWithCompatibleBrowser = browser.IS_IPAD && (browser.IS_SAFARI || IS_CHROME);

const defaultOptions = {
  // 'mobile', 'tablet', 'desktop'
  showButtonToggleMessangerOnDevices: []
};

const MAX_FILES_LENGTH = 10;
const MAX_FILE_SIZE_IN_BYTES = 5242880; // 5Mb
const ALLOWED_FILE_TYPES = "image/png, image/jpeg, image/jpg";

export default function chat(options) {
  const player = this;
  const mergedOptions = videojs.mergeOptions(defaultOptions, options);
  let chatWasVisibleBeforeFullscreen;

  composeUI(this);

  let attachedFiles = [];

  const generatedAvatars = {};
  const getGeneratedAvatarForUser = (userName) => {
    if (generatedAvatars[userName]) {
      return generatedAvatars[userName];
    }

    generatedAvatars[userName] = utils.generateAvatar(userName);
    return generatedAvatars[userName];
  }

  this.ready(() => {
    initializeFullscreenChangeHandler(this, mergedOptions);
    const chatApi = new ChatApi(this, options);
    const authService = new AuthService(options);
    const providers = authService.availableProviders;

    Component.registerComponent('ChatMessangerModalDialogWithImage', ModalDialogWithImage);
    const modalDialogWithImage = this.addChild('ChatMessangerModalDialogWithImage', {
      pauseOnOpen: false,
      temporary: false
    });
    const chatPopup = this.addChild(
      'ChatPopup',
      videojs.mergeOptions(options, { chatApi, providers }),
      this.children_.length
    );
    const chatMessanger = this.addChild(
      'ChatMessanger',
      videojs.mergeOptions(options, {
        chatApi,
        getGeneratedAvatarForUser,
        getAttachedFilesComponent: () => attachedFilesComponent,
        onShowImage: (imageData) => {
          modalDialogWithImage.open(imageData);
        },
      }),
      this.children_.length
    );
    chatApi.chatPopup = chatPopup;
    chatApi.chatMessanger = chatMessanger;

    Component.registerComponent('ChatMessangerErrorAttachFile', ErrorAttachFile);
    const errorModalDialog = this.addChild('ChatMessangerErrorAttachFile', {
      pauseOnOpen: false,
      temporary: false
    });

    Component.registerComponent('ChatMessangerAttachedFiles', AttachedFiles);
    const attachedFilesComponent = chatMessanger.addChild('ChatMessangerAttachedFiles', {
      className: 'vjs-chat-form-body__attached-files',
      maxFilesLength: MAX_FILES_LENGTH,
      onFilesLengthError: () => {
        errorModalDialog.openWithErrorMessage(`Вы можете прикрепить к сообщению не более ${MAX_FILES_LENGTH} файлов`);
      },
      onUpdate: (files) => {
        chatMessanger.toggleClass('vjs-chat-messanger_attached-files', files.length > 0);
        attachedFiles = files;
      }
    });

    Component.registerComponent('ChatMessangerButtonAttach', ButtonAttach);
    const buttonAttach = chatMessanger.addChild('ChatMessangerButtonAttach', {
      className: 'vjs-chat-form-body__attach',
      maxFileSize: MAX_FILE_SIZE_IN_BYTES,
      allowedFileTypes: ALLOWED_FILE_TYPES,
      handleFileSizeError: () => {
        errorModalDialog.openWithErrorMessage(`Вес файла не должен превышать ${MAX_FILE_SIZE_IN_BYTES / 1024 / 1024} МБ`);
      },
      handleFileTypeError: () => {
        errorModalDialog.openWithErrorMessage(`Допустимые форматы файлов для загрузки: ${ALLOWED_FILE_TYPES.replace(/image\//gi, '')}`);
      },
      handleSuccess: (files) => {
        attachedFilesComponent.add(files);

        const streamShoppingSlider = player.getChild('StreamShoppingSlider');
        if (streamShoppingSlider) {
          streamShoppingSlider.updateBottomPosition();
        }
      }
    });

    let listenEvents = 0;
    let restoreAuthCb  = () => {
      listenEvents++;
      if (listenEvents == 2) {
        // Выполняем проверку наличия сохраненной авторизации у пользователя сразу после загрузки всех
        // скриптов
        // NOTE: пока что такая возможность только для авторизации по электронной почте
        if (authService.isUserAuthorized()) {
          // По возможности восстанавливаем данные об авторизации, чтобы не проходить процедуру
          // авторизации заново
          authService.restoreUserAuth();
        };
      }
    }

    // Загрузка и инициализация плагинов соц. сетей
    chatApi.one('connected', restoreAuthCb);
    chatApi.connect();
    authService.one('scriptsLoaded', restoreAuthCb);
    authService.loadProviderScripts();

    /**
     * Авторизация пользователя в сервисе авторизации происходит следующим образом:
     *   1) Пользователь выбирает в UI способ авторизации (событие authProviderChoosed)
     *   2) Пользователь проходит процедуру авторизации в сервисе авторизации (событие
     *      providerAuthorized)
     *   2.1) В некоторых случаях в процессе авторизации требуется отображение дополнительных
     *        инструкций, требующихся для прохождения авторизации (например, отправка электронного
     *        письма; событие - providerInstructionsSent)
     *   3) Пользователь вводит имя, отображаемое в чате и таким образом подтверждает свое намерение
     *      писать что-либо в чате (событие confirmedAuthorization)
     *   4) Авторизация пользователя в чате (событие chatAuthorized)
     */

    // Колбек для события выбора социальной сети для авторизации
    chatPopup.on('authProviderChoosed', (event) => {
      let { provider, authData } = event.data;
      authService.authorize(provider, authData);
    });
    // Колбек для события авторизации в социальной сети
    authService.on('providerAuthorized', (event) => {
      let { provider, userData } = event.data;
      chatPopup.showUserForm(provider, userData);
    });
    // Колбек для отображения инструкция для продолжения процесса авторизации
    authService.on('providerInstructionsSent', (event) => {
      let { provider } = event.data;
      chatPopup.showInstructions(provider);
    });
    authService.on('providerConfirmedAuthorization', (event) => {
      let { userData } = event.data;
      chatPopup.completeAuthorization(userData);
    });
    authService.on('providerError', (event) => {
      let { error } = event.data;
      chatPopup.showError(error);
    });
    // Колбек по завершению процедуры сбора данных от пользователя
    chatPopup.on('confirmedAuthorization', (event) => {
      // Осуществляем авторизацию в сервисе чата
      chatApi.userAuthorize(event.data.userData);
    });
    // Колбек при авторизации в сервисе чата
    chatApi.on('chatAuthorized', () => {
      chatPopup.hide();
    });

    const handleClick = chatMessanger.toggleVisibility.bind(chatMessanger);
    addButtonToggleMessanger(this, videojs.mergeOptions(mergedOptions, { handleClick }));

    this.el_.classList.add('vjs-chat');

    if (options.likes) {
      this.addClass('vjs-likes');
      this.addChild('Likes', videojs.mergeOptions(options.likes, {chatApi}));
    }
  });

  function initializeFullscreenChangeHandler(player, options) {
    let hasEnteredFullscreen = false;

    const handleVisibilityChange = () => {
      const isPlayerFullscreen = document.fullscreenElement === player.el();

      if (isPlayerFullscreen && !hasEnteredFullscreen && isIpadWithCompatibleBrowser) {
        saveChatVisibilityState(player);
        hasEnteredFullscreen = true;
      } else if (!isPlayerFullscreen) {
        hasEnteredFullscreen = false;
      }

      // Убираем фокус с текстового поля чата, если он там находится, чтобы закрыть клавиатуру
      const chatMessanger = player.getChild('ChatMessanger');
      if (chatMessanger) {
        const commentTextEl = chatMessanger.commentTextEl;
        if (document.activeElement === commentTextEl) {
          commentTextEl.blur();
        }
      }

      setTimeout(() => {
        toggleChatAndButtonVisibility(player, options, !isPlayerFullscreen);
      }, 500);
    };

    player.on('fullscreenchange', handleVisibilityChange);

    screen.orientation.addEventListener('change', handleVisibilityChange);

    player.on('dispose', () => {
      screen.orientation.removeEventListener('change', handleVisibilityChange);
    });
  }

  function saveChatVisibilityState(player) {
    const chatMessanger = player.getChild('ChatMessanger');
    if (chatMessanger) {
      chatWasVisibleBeforeFullscreen = chatMessanger.checkVisibility();
    }
  }

  function toggleChatAndButtonVisibility(player, options, exitingFullscreen) {
    const isPlayerFullscreen = document.fullscreenElement === player.el();
    const chatMessanger = player.getChild('ChatMessanger');
    const buttonToggleMessanger = player.getDescendant(['controlBar', 'ButtonToggleMessanger']);
    const streamShoppingSlider = player.getChild('StreamShoppingSlider');

    const shouldHide = isIpadWithCompatibleBrowser && isPlayerFullscreen;
    const viewMode = player.el().dataset.viewMode;
    const shouldKeepChatVisibility = options.showButtonToggleMessangerOnDevices.includes(viewMode);

    if (chatMessanger && shouldHide && chatMessanger.checkVisibility()) {
      chatMessanger.toggleVisibility();
    } else if (exitingFullscreen) {
      if (chatWasVisibleBeforeFullscreen && !chatMessanger.checkVisibility()) {
        chatMessanger.toggleVisibility();
      }
      chatMessanger.handleResize();
    }

    if (streamShoppingSlider) {
      streamShoppingSlider.updateWidth();
    }

    if (buttonToggleMessanger && (shouldHide || !shouldKeepChatVisibility)) {
      buttonToggleMessanger.hide();
    } else {
      buttonToggleMessanger.show();
    }
  }

  function addButtonToggleMessanger(player, options) {
    const controlBar = player.getChild('controlBar');
    if (controlBar === undefined) {
      return;
    }

    const customControlSpacer = controlBar.getChild('customControlSpacer');
    if (customControlSpacer === undefined) {
      return;
    }

    const index = controlBar.children_.indexOf(customControlSpacer) + 1;

    controlBar.addChild('ButtonToggleMessanger', options, index);
  }
}

// Cross-compatibility for Video.js 5 and 6.
const registerPlugin = videojs.registerPlugin || videojs.plugin;
registerPlugin('chat', chat);
